module.exports = __webpack_public_path__ + "static/sgnOverview-94549904b1bcd6a227480569c76814c9.svg";